export default {
  affiliate: {
    // Main navigation
    title: 'Affiliate',
    cantFindQuestion: 'Hindi mahanap ang tanong?',
    onlineService: 'Online na Serbisyo',
    dashboard: 'Dashboard',
    myRewards: 'Aking mga Gantimpala',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'Mga Gantimpala sa Imbitasyon',
    rules: 'Mga Patakaran',

    // Team Info
    teamData: 'Data ng Koponan',
    details: 'Mga Detalye',
    totalValidFriends: 'Kabuuang wastong kaibigan:',
    todayTotalWager: 'Kabuuang taya ngayong araw:',
    rewards: 'Mga Gantimpala',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Komisyon sa Pag-imbita ng Kaibigan Hanggang',
    expandTeamBonus: 'Bonus sa Pagpapalawak ng Koponan',
    maxLevelCommission: 'Pinakamataas na Antas ng Komisyon',
    inviteFriendsCommission: 'Komisyon sa Pag-imbita ng Kaibigan',
    maxPerformanceCommission: 'Pinakamataas na Komisyon sa Pagganap',
    unlimitedAgent: 'Walang Hanggang Ahente',
    unlimitedCommission: 'Walang Hanggang Komisyon',
    commissionRate: 'Rate ng Komisyon',

    // Team Invite Friends
    inviteFriendsToEarn: 'MAG-IMBITA NG MGA KAIBIGAN UPANG KUMITA',
    link: 'Link',
    code: 'Code',
    inviteFriends: 'Mag-imbita ng mga kaibigan',
    share: 'Ibahagi',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'Kunin',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'Natanggap Ngayong Araw',
    
    liveRewards: 'Live Rewards',
    sendTotalCommission: 'Ipadala ang kabuuang komisyon',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'Mga Kaibigan na Inimbita Ngayong Araw',
    todayDepositFriends: 'Mga Kaibigan na Nag-deposit Ngayong Araw',
    depositFriends: 'Mga Kaibigan na Nag-deposit',
    validFriends: 'Wastong Kaibigan',

    // Dialogs
    shareInvitationLink: 'Ibahagi ang iyong invitation link para makapag-register sila.',
    shareInvitationCode: 'Ibahagi ang iyong invitation code para mailagay nila sa panahon ng registration.',
    shareQRCode: 'Ibahagi ang iyong QR code para ma-scan at makapag-register sila.',

    // Share Dialog
    shareTitle: 'Ibahagi',
    player: 'Manlalaro',
    saveImage: 'I-save ang larawan',
    saveImageSuccess: "Na-save ang larawan",
    saveImageFailed: "Nabigo ang pag-save, subukan ulit",
    copy: 'Kopyahin',
    copied: 'Nakopya!',

    // Received/Withdraw
    received: 'Natanggap',
    withdraw: 'Mag-withdraw',
    history: 'Kasaysayan',
    referralRewards: 'Mga Gantimpala sa Referral',
    commission: 'Komisyon',
    depositRebate: 'Rebate sa Deposit',
    levelUpRewards: 'Mga Gantimpala sa Pag-level Up',
    loading: 'Naglo-load...',
    noMoreRecords: 'Wala nang iba pang record',
    loadMore: 'Mag-load pa',
    pending: 'Nakabinbin',
    paid: 'Nabayaran',
    rejected: 'Tinanggihan',
    unknown: 'Hindi Alam',
    upgradeReward: 'Gantimpala sa Pag-upgrade',
    cancelled: 'Kinansela',
    receiving: 'Tinatanggap',
    failed: 'Nabigo',
    expired: 'Nag-expire',

    // History Dialog
    pickDate: 'Pumili ng petsa',
    select: 'Pumili',
    chooseBonus: 'Pumili ng bonus',
    all: 'Lahat',

    // Invitation Rewards Page
    yourFriendGet: 'Ang iyong kaibigan ay makakakuha',
    dailyInvitations: 'Araw-araw na mga imbitasyon',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'Paano kumita ng affiliate rewards?',
    shareToFriends: 'Ibahagi sa mga kaibigan',
    shareReferralLink: 'Ibahagi ang iyong referral link, code o QR code sa iyong mga kaibigan',
    friendsSignUpDeposit: 'Ang mga kaibigan ay mag-sign up at mag-deposito',
    inviteFriendsRegisterDeposit: 'Mag-imbita ng mga kaibigan na magrehistro sa AFUN at gumawa ng unang deposito.',
    getUpTo: 'Makakuha ng hanggang',
    earnBigRewards: 'Kumita ng rewards at komisyon kapag tumaya, nag-deposito, at nakaabot sa VIP ang mga kaibigan.',
    noticeEnsureCorrect: 'Paalala: Tiyaking tama ang invitation link, QR code, o code.',

    // Rules - Commission Work
    howCommissionWork: 'Paano gumagana ang Komisyon?',
    agentRatingDescription: 'Paglalarawan ng Rating ng Ahente',
    you: 'IKAW',
    commissionDescription: 'Kumita ng komisyon mula sa mga deposito at taya ng iyong mga Kaibigan B, C, D, at higit pa. Tingnan ang tsart sa kanan para sa mga rate ng komisyon.',
    claimConditions: 'Mga kondisyon sa pag-claim',
    teamLevel: 'Antas ng Koponan',
    earnUpTo: "Earn up to",
    expandYourTeam: "Palawakin ang Iyong Team",
    earnAnExtra: "Kumita ng Dagdag",
    upgradeAgentLevel: "I-upgrade ang Iyong Agent Level",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'Kabuuang Laki',
    teamWager: 'Taya ng Koponan',
    rebateRewardVary: 'Ang Rebate Reward at Top Up Reward ay nag-iiba batay sa iyong Team level sa araw na iyon.',
    teamSizeDescription: 'Laki ng koponan: Ang bilang ng mga valid na user na mayroon ka sa kasalukuyan.',
    teamBettingDescription: 'Taya ng koponan: Ang kabuuang bilang ng mga taya na ginagawa ng iyong mga subordinate sa isang araw.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'KOMISYON NG TEAM',
    teamCommissionSubTitle: 'Kumita sa bawat deposito at\nbawat taya sa iyong network.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Mag-imbita ng mga kaibigan, at pareho silang makakatanggap ng mga gantimpala',
    inviteRegisterReceive: 'Matagumpay na mag-imbita ng mga kaibigan na magrehistro at makatanggap',
    friendDepositWagerUnlock: 'Kapag nag-deposito ang iyong kaibigan ng 10.00 USDT at tumaya ng 50.00 USDT, mao-unlock mo ang 3.00 USDT na reward, at makakakuha ang iyong kaibigan ng 2.00 USDT.',
    inviteFriendToGet: 'Mag-imbita ng kaibigan upang makakuha',
    inviteFriendsEarnRewards: 'Mag-imbita ng mga kaibigan at kumita ng mga reward',
    howMakeFriendsSubordinates: 'Paano gawing subordinate ang mga kaibigan:',
    howMakeFriendsValidUsers: 'Paano gawing valid na user ang iyong mga kaibigan:',
    successfullyInviteFriends: 'Matagumpay na nag-imbita ng mga kaibigan na mag-sign up.',
    cumulativeDepositsReach: 'Ang kanilang pinagsama-samang deposito ay umaabot sa 10.00 USDT.',
    cumulativeValidBetsReach: 'Ang kanilang pinagsama-samang valid na taya ay umaabot sa 50.00 USDT.',
    thenBecomeValidUsers: 'Pagkatapos, magiging valid na user sila.',
    depositFriendsDescription: 'Kapag matagumpay na nag-deposito ng pera ang iyong mga subordinate na kaibigan, magiging depositing friends sila.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Kamakailang Inimbitahang Kaibigan',
    recentDepositFriends: 'Kamakailang Nag-deposit na Kaibigan',
    today: 'Ngayong Araw',
    yesterday: 'Kahapon',
    thisMonth: 'Ngayong buwan',
    friendsData: 'Data ng mga Kaibigan',
    joinDate: 'Petsa ng Pagsali',
    search: 'Maghanap',
    level: 'Antas',
    tier: 'Antas',
    affiliateTreasureBox: 'Kahon ng Kayamanan ng Affiliate',
    referralRewardsDesc: 'Kapag nag-imbita ka ng mga kaibigan na magrehistro, parehong makakatanggap ng magandang bonus ikaw at ang iyong mga kaibigan.',
    commissionDesc: 'Ikaw at ang iyong koponan ay magkasamang nagtatrabaho upang makamit ang inyong mga layunin at kumita ng magandang komisyon.',
    affiliateTreasureBoxDesc: 'Mag-imbita ng mga kaibigan upang makakuha ng milestone bonus',
  }
};
